export default __webpack_public_path__ + "static/media/drive_folder.99cfb7dc.png";